import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { useParams } from 'react-router-dom';

import ButtonHeader from '../components/ButtonHeader.jsx';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    minHeight: '600px',
  },
  listItemText: {
    marginRight: theme.spacing(1),
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const globalPageData = [
  {
    pageName: 'globalSetting',
    detail: {
      heading: 'Global Settings',
      btnLists: [
        // TODO: Enable Post 4.8 Release
        // {
        //   linkTo: '/cardFormats',
        //   linkText: 'Card Format(s)',
        // },
        // {
        //   linkTo: '/scheduler',
        //   linkText: 'Scheduler',
        // },
        // {
        //   linkTo: '/photorecall',
        //   linkText: 'Photo Recall Configuration',
        // },
        {
          linkTo: '/mobilecredential',
          linkText: 'Mobile Credentials',
        },
        {
          linkTo: '/userconfig',
          linkText: 'User Configuration Settings',
        },
      ],
    },
  },
  {
    pageName: 'cardSetting',
    detail: {
      heading: 'Cardholder & Card Settings',
      btnLists: [
        {
          linkTo: '/cardholderfields',
          linkText: 'Custom Record Fields',
        },
      ],
    },
  },
  {
    pageName: 'userSetting',
    detail: {
      heading: 'User Configuration Settings',
      btnLists: [
        {
          linkTo: '/homepage',
          linkText: 'User Configuration Settings',
        },
      ],
    },
  },
];

const GlobalSettings = () => {
  const classes = useStyles();
  const params = useParams();

  const pageData = globalPageData.find((page) => page.pageName === params.id);

  return (
    <>
      {pageData && (
        <>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <Link color="inherit" href="/admin">
              Administration
            </Link>
            <Typography color="textPrimary">{pageData.detail.heading}</Typography>
          </Breadcrumbs>
          <br />
          <ButtonHeader title={pageData.detail.heading} />
          <div className={classes.root}>
            <Paper className={classes.content}>
              <List
                component="nav"
                aria-label={pageData.detail.heading}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  alignContent: 'flex-start',
                }}
              >
                {pageData.detail.btnLists.map((item) => (
                  <Link color="inherit" href={item.linkTo} key={item.linkText}>
                    <ListItem button>
                      <ListItemText primary={item.linkText} className={classes.listItemText} />
                      <ListItemIcon>
                        <PlayCircleOutlineIcon />
                      </ListItemIcon>
                    </ListItem>
                  </Link>
                ))}
              </List>
            </Paper>
          </div>
        </>
      )}
    </>
  );
};

export default GlobalSettings;
